const stripSlashStart = (path) => {
    return path.startsWith('/') ? path : `/${path}`;
};
export const endpoint = (baseUrl, path) => {
    const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    return `${normalizedBaseUrl}${stripSlashStart(path)}`;
};
